import clsx from 'clsx'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import 'src/components/voicealbum/custom.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import BtnBefore from 'src/assets/img/common/pink_backward_rounded_vector.png'

const ArrowLeft = ({ onClick, className, style }) => {
  if (className && className.includes('slick-disabled')) {
    return null
  } else {
    return (
      <div
        className={className}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          left: '-25px',
          top: '45%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          cursor: 'pointer'
        }}
        onClick={onClick}
      >
        <img src={BtnBefore} className="!h-9" alt="left arrow" />
      </div>
    )
  }
}

const ArrowRight = ({ onClick, className, style }) => {
  if (className && className.includes('slick-disabled')) {
    return null
  } else {
    return (
      <div
        className={clsx(className)}
        style={{
          ...style,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          right: '-25px',
          top: '45%',
          transform: 'translateY(-50%) rotate(180deg)',
          zIndex: 2,
          cursor: 'pointer'
        }}
        onClick={onClick}
      >
        <img src={BtnBefore} className="!h-9" alt="right arrow" />
      </div>
    )
  }
}

const Carousel = ({ characters, setActiveIndex, activeIndex }) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 100,
    cssEase: 'linear',
    touchThreshold: 20,
    slidesToShow: 5,
    slidesToScroll: 2,
    swipeToSlide: true,
    draggable: true,
    arrows: true,
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
    initialSlide: activeIndex < 6 ? activeIndex : activeIndex - 2
  }

  return (
    <div className="relative px-7 voice-album">
      <Slider {...settings}>
        {characters.map(
          (img, index) =>
            img.active && (
              <div key={index} onClick={() => setActiveIndex(index)}>
                <img
                  src={activeIndex === index ? img.active : img.deactive}
                  alt={img.alt || `Slide ${index + 1}`}
                />
              </div>
            )
        )}
      </Slider>
    </div>
  )
}

Carousel.propTypes = {
  characters: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  setActiveIndex: PropTypes.func.isRequired
}

ArrowRight.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

ArrowLeft.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default Carousel
